/* Certification Service Module */
import { CERTIFICATION_001, CERTIFICATION_003, CERTIFICATION_005, CERTIFICATION_008 } from '../error';
import {
  CreateEmailCertificationCheckEmailReqBody,
  CreateEmailCertificationResetPwReqBody,
  CreateMemberEmailCertificationCheckEmailReqBody,
  CreateMobileCertificationReqBody,
  FindEmailReqBody,
  ResetPwReqBody,
  VerifyEmailCertificationReqBody,
  VerifyMemberEmailCertificationReqBody,
  VerifyMobileCertificationReqBody,
} from '../schema';
import type { ResetPwControllerReqBodyType } from '../type';

export const validateCreateMobileCertificationReqBody = (body: Record<string, any>) => {
  const parse_body = CreateMobileCertificationReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_001(parse_body.error);
  }

  return parse_body.data;
};

export const validateVerfityMobileCertificationReqBody = (body: Record<string, any>) => {
  const parse_body = VerifyMobileCertificationReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_003(parse_body.error);
  }

  return parse_body.data;
};

export const validateFindEmailReqBody = (body: Record<string, any>) => {
  const parse_body = FindEmailReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_005(parse_body.error);
  }

  return parse_body.data;
};

export const validateCreateEmailCertificationResetPwReqBody = (body: Record<string, any>) => {
  const parse_body = CreateEmailCertificationResetPwReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_001(parse_body.error);
  }

  return parse_body.data;
};

export const validateVerifyEmailCertificationReqBody = (body: Record<string, any>) => {
  const parse_body = VerifyEmailCertificationReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_003(parse_body.error);
  }

  return parse_body.data;
};

export const validateVerifyMemberEmailCertificationReqBody = (body: Record<string, any>) => {
  const parse_body = VerifyMemberEmailCertificationReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_003(parse_body.error);
  }

  return parse_body.data;
};

export const validateResetPwReqBody = (body: ResetPwControllerReqBodyType) => {
  const parse_body = ResetPwReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_008(parse_body.error);
  }

  return parse_body.data;
};

export const validateCreateEmailCertificationCheckEmailReqBody = (body: Record<string, any>) => {
  const parse_body = CreateEmailCertificationCheckEmailReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_001(parse_body.error);
  }

  return parse_body.data;
};

export const validateCreateMemberEmailCertificationCheckEmailReqBody = (body: Record<string, any>) => {
  const parse_body = CreateMemberEmailCertificationCheckEmailReqBody.safeParse(body);

  if (!parse_body.success) {
    throw CERTIFICATION_001(parse_body.error);
  }

  return parse_body.data;
};
